import React from 'react'

const AdminHome = () => {
  return (
    <div>
        <section className="section">
           
        </section>
    </div>
  )
}

export default AdminHome